"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../shared/components/table_actions/TableActionDelete");
var TableActionEdit_1 = require("../../../../../../shared/components/table_actions/TableActionEdit");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var TableMenuIsDeprecated_1 = require("../../../../../../shared/components/table_menus/TableMenuIsDeprecated");
var FontAwesome_1 = require("../../../../../../shared/components/icons/FontAwesome");
var ButtonLockLockAll_1 = require("../../../../../../shared/components/buttons/ButtonLockLockAll");
var ButtonLockUnLockAll_1 = require("../../../../../../shared/components/buttons/ButtonLockUnLockAll");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var TableActionFlag_1 = require("../../../../../../shared/components/table_actions/TableActionFlag");
var CfgCountryList = /** @class */ (function (_super) {
    __extends(CfgCountryList, _super);
    function CfgCountryList(props) {
        var _this = _super.call(this, props) || this;
        _this.searchTitleInput = null;
        _this.searchISOInput = null;
        _this.PAGE_NUM_ONE = 1;
        return _this;
    }
    CfgCountryList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
            searchTitleFilter: [],
            searchTitleValue: "",
            isSearchTitle: false,
            searchISOFilter: [],
            searchISOValue: "",
            isSearchISO: false,
        }, function () {
            _this.props.data.LoadData();
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    CfgCountryList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    CfgCountryList.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize
            }, function () {
                nextProps.data.LoadData();
            });
        }
    };
    CfgCountryList.prototype.doDeprecateAction = function (Key, Title, Lock) {
        var _this = this;
        this.props.data.SetIsDeprecated(Key, Lock, function () {
            if (Lock) {
                notificationHelper_1.default.ShowTopRightNotificationText(UIUtils_1.UIUtils.FormatStr(_this.props.lang.list.message.set_as_deprecated_fmt, [Title]));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotificationText(UIUtils_1.UIUtils.FormatStr(_this.props.lang.list.message.set_as_actual_fmt, [Title]));
            }
        });
    };
    CfgCountryList.prototype.onClearTitleFilter = function () {
        var _this = this;
        this.setState({
            searchTitleFilter: [],
            searchTitleValue: "",
            isSearchTitle: false,
        }, function () {
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(_this.PAGE_NUM_ONE, _this.state.pageSize);
            }
        });
    };
    CfgCountryList.prototype.onChangeTitleFilter = function (e) {
        this.setState({ searchTitleValue: e.target.value });
    };
    CfgCountryList.prototype.onConfirmTitleFilter = function () {
        var _this = this;
        this.setState({
            searchTitleFilter: [this.state.searchTitleValue],
            isSearchTitle: true
        }, function () {
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(_this.PAGE_NUM_ONE, _this.state.pageSize);
            }
        });
    };
    CfgCountryList.prototype.onClearISOFilter = function () {
        var _this = this;
        this.setState({
            searchISOFilter: [],
            searchISOValue: "",
            isSearchISO: false,
        }, function () {
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(_this.PAGE_NUM_ONE, _this.state.pageSize);
            }
        });
    };
    CfgCountryList.prototype.onChangeISOFilter = function (e) {
        this.setState({ searchISOValue: e.target.value });
    };
    CfgCountryList.prototype.onConfirmISOFilter = function () {
        var _this = this;
        this.setState({
            searchISOFilter: [this.state.searchISOValue],
            isSearchISO: true
        }, function () {
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(_this.PAGE_NUM_ONE, _this.state.pageSize);
            }
        });
    };
    CfgCountryList.prototype.getColumns = function () {
        var _this = this;
        var _title_filter = this.state.searchTitleFilter;
        var _iso_filter = this.state.searchISOFilter;
        return [
            {
                title: this.props.lang.list.rows.title,
                dataIndex: this.props.data.dk_title,
                key: this.props.data.dk_title,
                width: 200,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchTitleInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u0438\u043C\u0435\u043D\u0438", value: _this.state.searchTitleValue, onChange: _this.onChangeTitleFilter.bind(_this), onPressEnter: function () { _this.onConfirmTitleFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmTitleFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearTitleFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _title_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.title.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchTitleInput.focus();
                        });
                    }
                }
            }, {
                title: this.props.lang.list.rows.code,
                dataIndex: this.props.data.dk_code,
                key: this.props.data.dk_code,
                align: "center",
                width: 100,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchISOInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043A\u043E\u0434\u0443", value: _this.state.searchISOValue, onChange: _this.onChangeISOFilter.bind(_this), onPressEnter: function () { _this.onConfirmISOFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmISOFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearISOFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _iso_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.code.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchISOInput.focus();
                        });
                    }
                }
            }, {
                title: this.props.lang.list.rows.date_added,
                dataIndex: this.props.data.dk_date_added,
                key: this.props.data.dk_date_added,
                align: "center",
                width: 200,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_changed.format(_this.props.state.getDateTimeFormat())));
                }
            }, {
                title: "Внутренний префикс",
                dataIndex: this.props.data.dk_phone_prefix_inner,
                key: this.props.data.dk_phone_prefix_inner,
                align: "center",
                width: 200,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.phone_prefix_inner));
                }
            }, {
                title: "Внешний префикс",
                dataIndex: this.props.data.dk_phone_prefix_outer,
                key: this.props.data.dk_phone_prefix_outer,
                align: "center",
                width: 200,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.phone_prefix_outer));
                }
            }, {
                title: "Css класс",
                dataIndex: this.props.data.dk_css_classname,
                key: this.props.data.dk_css_classname,
                align: "center",
                width: 200,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.css_classname));
                }
            }, {
                title: "Кол-во локализаций",
                dataIndex: this.props.data.dk_locales_count,
                key: this.props.data.dk_locales_count,
                align: "center",
                width: 200,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.locales_count));
                }
            }, {
                title: this.props.lang.list.rows.deprecated.title,
                dataIndex: this.props.data.dk_is_deprecated,
                key: this.props.data.dk_is_deprecated,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsDeprecated_1.default, { notDeprecatedTexts: {
                            menu: _this.props.lang.list.rows.deprecated.menu.actual.menu,
                            text: _this.props.lang.list.rows.deprecated.menu.actual.text
                        }, deprecatedTexts: {
                            menu: _this.props.lang.list.rows.deprecated.menu.deprecate.menu,
                            text: _this.props.lang.list.rows.deprecated.menu.deprecate.text
                        }, record: {
                            key: record.key,
                            title: record.title,
                            deprecated: record.is_deprecated
                        }, onDeprecateClick: _this.doDeprecateAction.bind(_this) }));
                },
                filters: [
                    { text: this.props.lang.list.rows.deprecated.filter.deprecate, value: 'true' },
                    { text: this.props.lang.list.rows.deprecated.filter.actual, value: 'false' },
                ],
                filterMultiple: false,
                onFilter: function (value, record) { return record.is_deprecated === (value === 'true'); },
                sorter: function (a, b) { return _this.bool2Int(a.is_deprecated) - _this.bool2Int(b.is_deprecated); },
                width: 150,
            }, {
                title: this.props.lang.list.rows.unknown.title,
                dataIndex: this.props.data.dk_is_unknown,
                key: this.props.data.dk_is_unknown,
                align: "center",
                width: 100,
                filters: [
                    { text: this.props.lang.list.rows.unknown.filter.unknown, value: 'true' },
                    { text: this.props.lang.list.rows.unknown.filter.known, value: 'false' },
                ],
                filterMultiple: false,
                onFilter: function (value, record) { return record.is_unknown === (value === 'true'); },
                sorter: function (a, b) { return _this.bool2Int(a.is_unknown) - _this.bool2Int(b.is_unknown); },
                render: function (text, record, idx) {
                    if (record.is_unknown) {
                        return (React.createElement("div", { style: { color: "#f5222d" } },
                            React.createElement(FontAwesome_1.FA, { left: true, icon: "check-square" }),
                            _this.props.lang.list.rows.unknown.render.yes));
                    }
                    else {
                        return (React.createElement("div", { style: { color: "#1890ff" } },
                            React.createElement(FontAwesome_1.FA, { left: true, icon: "square" }),
                            _this.props.lang.list.rows.unknown.render.no));
                    }
                }
            }, {
                title: this.props.lang.list.rows.action.title,
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionEdit_1.default, { hint: _this.props.lang.list.rows.action.edit, onClick: function () {
                            _this.onEditClick(record);
                        } }),
                    React.createElement(TableActionFlag_1.default, { hint: "\u041B\u043E\u043A\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438", onClick: function () { _this.onTranslateClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: _this.props.lang.list.rows.action.delete.hint, confirmText: _this.props.lang.list.rows.action.delete.confirm, onClick: function () {
                            _this.onDeleteClick(record);
                        } }))); },
                width: 100
            }
        ];
    };
    CfgCountryList.prototype.bool2Int = function (val) {
        if (val) {
            return 1;
        }
        else {
            return 0;
        }
    };
    CfgCountryList.prototype.onEditClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    CfgCountryList.prototype.onTranslateClick = function (record) {
        if (this.props.onEditLocaleClick) {
            this.props.onEditLocaleClick(record);
        }
    };
    CfgCountryList.prototype.onDeleteClick = function (record) {
        var _this = this;
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotificationText(UIUtils_1.UIUtils.FormatStr(_this.props.lang.list.message.country_deleted_fmt, [record.title])
            //`Страна ${record.title} была успешно удалена`
            );
        });
    };
    CfgCountryList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        this.setState({ pageNum: _page, pageSize: PageSize }, function () {
            _this.props.data.LoadData(function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, PageSize);
                }
            });
        });
    };
    CfgCountryList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData();
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
    };
    CfgCountryList.prototype.onLockAllClick = function () {
        var _this = this;
        this.props.data.SetAllIsDeprecated(true, function () {
            notificationHelper_1.default.ShowTextTopRightInfoNotify(_this.props.lang.list.message.all_country_deprecated);
        });
    };
    CfgCountryList.prototype.onUnLockAllClick = function () {
        var _this = this;
        this.props.data.SetAllIsDeprecated(false, function () {
            notificationHelper_1.default.ShowTextTopRightInfoNotify(_this.props.lang.list.message.all_country_actual);
        });
    };
    CfgCountryList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: {
                    create: this.props.lang.list.toolbars.hints.create,
                    refresh: this.props.lang.list.toolbars.hints.refresh
                }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(antd_1.Popconfirm, { placement: "bottom", title: this.props.lang.list.toolbars.lock_all.confirm_title, okText: this.props.lang.list.toolbars.lock_all.ok_text, cancelText: this.props.lang.list.toolbars.lock_all.cancel_text, onConfirm: this.onLockAllClick.bind(this) },
                    React.createElement(ButtonLockLockAll_1.default, { hint: this.props.lang.list.toolbars.lock_all.button_hint, onClick: function () { } })),
                React.createElement(antd_1.Popconfirm, { placement: "bottom", title: this.props.lang.list.toolbars.unlock_all.confirm_title, okText: this.props.lang.list.toolbars.unlock_all.ok_text, cancelText: this.props.lang.list.toolbars.unlock_all.cancel_text, onConfirm: this.onUnLockAllClick.bind(this) },
                    React.createElement(ButtonLockUnLockAll_1.default, { hint: this.props.lang.list.toolbars.unlock_all.button_hint, onClick: function () { } }))),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.getColumns(), dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return (React.createElement("div", null, UIUtils_1.UIUtils.FormatStr(_this.props.lang.list.footer.title_fmt, [data.length.toString(), _this.state.totalRows.toString()])));
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, _this.props.lang.list.details.created),
                            " [",
                            record.date_added.format(_this.props.state.getDateTimeFormat()),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, _this.props.lang.list.details.changed),
                            " [",
                            record.date_changed.format(_this.props.state.getDateTimeFormat()),
                            "]")));
                }, scroll: { x: true } })));
    };
    return CfgCountryList;
}(React.Component));
exports.default = CfgCountryList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_country/ui/component/CfgCountryList.tsx
// module id = 2051
// module chunks = 0